import {
  Box,
  ListItemIcon,
  MenuItem,
  MenuItemProps,
  useTheme,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";

type NavigationItemProps = MenuItemProps & {
  to: string;
  toAlternative?: string;
  icon?: ReactNode;
};

export const NavigationItem = observer(
  ({ to, icon, toAlternative, ...props }: NavigationItemProps) => {
    let resolved = useResolvedPath(to);
    let resolvedAlternative =
      toAlternative != null ? useResolvedPath(toAlternative) : undefined;
    const match = useMatch({ path: resolved.pathname, end: true });
    const matchSecond = resolvedAlternative
      ? useMatch({ path: resolvedAlternative.pathname, end: true })
      : false;

    const navigate = useNavigate();
    const theme = useTheme();
    return (
      <MenuItem
        onClick={() => navigate(to)}
        {...props}
        sx={{
          ...props.sx,
          minHeight: "48px",
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
          "&.Mui-selected": {
            backgroundColor: theme.palette.secondary.main,
          },
          textTransform: "capitalize",
        }}
        selected={match || matchSecond ? true : false}
      >
        <ListItemIcon>{icon}</ListItemIcon>

        <Box sx={{ minWidth: "120px", maxWidth: "200px" }}>
          {props.children}
        </Box>
      </MenuItem>
    );
  }
);
